<div class="cart">


  <div *ngIf="isSub" class="m-4 border border-principal rounded-md mb-4 p-3">
    <div *ngFor="let product of cart; let i = index" class="flex gap-3 py-3 mb-4 w-full">
      <div class="w-20 h-20 flex-none flex items-stretch relative">
        <img class="w-full h-full object-contain"
          [src]="product.variation.images.length > 0 ? product.variation.images[0].url : product.product.images.length > 0 ? product.product.images[0].url : default_photo"
          alt="" />
        <!-- <img  class="w-full h-full object-contain" [src]="currentProduct.mainImage != '' ? currentProduct.mainImage : default_photo "> -->

        <!--<img 
            *ngIf="
              product.variation.images.length === 0 || !product.variation.images
            "
            class="w-full h-full object-contain"
            [src]="
              product.variation.image ? product.variation.image : default_photo
            "
            alt=""
          /> -->
      </div>
      <div class="flex-1 flex flex-wrap gap-3 justify-between">
        <div class="w-full text-sm capitalize">
          <p class="font-semibold flex">
            <span class="flex-1 text-base">{{ product.variation.name }}</span>
            <button (click)="close(i)"
              class="material-icons-outlined hover:text-white focus:text-white hover:bg-red-500 focus:bg-red-500 w-8 h-8 rounded -mt-2">
              close
            </button>
          </p>
          <!-- <span class="italic text-xs text-gris-claro">SKU: {{  product.variation.product_sku  }}</span> -->
          <ng-container *ngIf="product.variation.variants_options && product.variation.variants_options.length > 0">
            <ul *ngFor="let variant of product.variation.variants_options"
              class="flex flex-wrap w-full italic text-xs text-gris-medio">
              <li *ngIf="variant != []">
                <b>{{ variant.name }}</b>: {{ variant.value }}
              </li>
            </ul>
          </ng-container>
        </div>
        <div class="flex justify-between gap-4 items-center self-end w-full">
          <div class="flex h-8 items-center self-end">
            <div class="border border-black text-info flex justify-between h-8 w-22 items-center">
              <button aria-label="Remove one" (click)="removeCantidad(i)"
                class="flex items-center justify-center hover:text-white focus:text-white hover:bg-red-500 focus:bg-red-500 text-md w-8 h-full">
                <span class="material-icons-outlined">remove</span>
              </button>
              <div class="w-6 text-center">
                <p class="">{{ product.variation.quantity }}</p>
              </div>
              <button aria-label="Add one more" (click)="addCantidad(product)"
                class="flex items-center justify-center hover:text-white focus:text-white hover:bg-red-500 focus:bg-red-500 text-md w-8 h-full">
                <span class="material-icons-outlined">add</span>
              </button>
            </div>
          </div>
          <div class="flex h-8 items-center self-end">
            <ng-container
              *ngIf="!product.variation.isSubscription || (product.variation.discountPrice == product.variation.price ) || (product.variation.discountPrice == product.variation.sale_price ); else subscribeTemplate">
              <p class="font-semibold text-lg uppercase h-8 flex items-center whitespace-nowrap"
                [ngClass]="product.variation.sale_price > 0 ? 'text-gris-claro line-through': 'text-principal' ">
                {{product.variation.price | currencyPersonalized}}
              </p>
              <p *ngIf="product.variation.sale_price > 0"
                class="pl-2 text-principal font-semibold text-lg uppercase h-8 flex items-center whitespace-nowrap">
                {{product.variation.sale_price | currencyPersonalized}} ??
              </p>
            </ng-container>

            <ng-template #subscribeTemplate>
              <!-- VOLVER A ACTIVAR POST EVENTO REDNUMBERS -->

              <!-- <p *ngIf="product.variation.sale_price > 0" class="font-semibold text-lg uppercase h-8 flex items-center whitespace-nowrap text-gris-claro line-through">
									{{ product.variation.sale_price | currencyPersonalized }}
								</p>
								<p *ngIf="product.variation.sale_price === 0" class="font-semibold text-lg uppercase h-8 flex items-center whitespace-nowrap text-gris-claro line-through">
									{{ product.variation.price | currencyPersonalized }}
								</p> -->
              <p
                class="font-semibold text-lg uppercase h-8 flex items-center whitespace-nowrap text-gris-claro line-through">
                {{ product.variation.price | currencyPersonalized }}
              </p>
              <p class="pl-2 text-principal font-semibold text-lg uppercase h-8 flex items-center whitespace-nowrap">
                {{ product.variation.discountPrice | currencyPersonalized }}
              </p>
            </ng-template>

          </div>
        </div>


        <div class="flex justify-between gap-4 items-center self-end"
          *ngIf="product.product.variants_options && product.product.variants_options.length > 0">
          <div class="flex h-6 items-center">
            <button (click)="changeVariati(product); changeVar = !changeVar" *ngIf="!changeVar"
              class="px-4 py-1 border rounded transition-all bg-red-500 text-white border-red-500">
              Change variant
            </button>
          </div>
          <div *ngIf="changeVar &&  (changeVar && product.product.product_sku == currentChange) == false">
            <p>loading...</p>
          </div>
          <div class="flex justify-between gap-4 items-center self-end"
            *ngIf="changeVar && product.product.product_sku == currentChange">
            <div *ngFor="let variation of varPropiedades; let i = index">
              <ul class="flex flex-wrap w-full gap-x-3 mb-6 mt-8 md:mt-0 max-w-screen-xl mx-auto">
                <li class="text-base font-bold text-black capitalize w-full">{{ variation.name }}</li>
                <li class="text-gris-medio tracking-4xsmall flex space-x-4">
                  <button *ngFor="let value of variation.values; let j = index"
                    class="px-4 py-1 text-xs border rounded transition-all"
                    [ngClass]="infoVar[i][0].value == value  ? 'bg-red-500 text-white border-red-500' : 'bg-white text-gray-700 border-gray-300'"
                    (click)="selected(variation, value, product.product); changeVar = !changeVar">
                    {{ value }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>

    </div>
    <!-- fin for -->
    <div class="w-full flex-row gap-3" *ngIf="subTypes.length > 0">
      <h2
        class="text-white font-poppins w-full flex justify-between items-center text-left uppercase text-lg sm:text-xl font-semibold py-3 px-4 rounded bg-principal-medio">
        {{'suscripcion.time' | translate}}
        <span class="material-icons-outlined mr-3">done</span>
      </h2>
      <div class="container-input container50 checkbox-especial">
        <div class="control-group">
          <label class="control control-radio cursor-pointer" *ngFor="let subType of subTypes">
            <span class="capitalize">{{subType.label }}</span>
            <input type="radio" name="radio_subType" [value]="subType.id_number"
              [checked]="subType.id_number == id_subscription" [(ngModel)]="id_subscription" />
            <div class="control_indicator"></div>
          </label>
        </div>
      </div>
    </div>

  </div>

  <!-- Datos personanles -->
  <div class="mb-4 bg-gris-extraclaro rounded">
    <h2 class="font-dunbar w-full flex justify-between items-center uppercase sm:text-lg py-2 px-6 cursor-pointer"
      (click)="changeStep(1)" [ngClass]="
        step == 1
          ? 'bg-gris-extraclaro'
          : 'mb-2 bg-gris-extraclaro hover:bg-principal-claro focus:bg-principal-claro'
      ">
      {{ 'carrito.datosPersonales' | translate }}
      <span *ngIf="step > 1" class="material-icons-outlined mr-3">done</span>
    </h2>
    <div class="grid grid-cols-2 gap-3 py-4 mx-4" *ngIf="step == 1">
      <div class="col-span-2">
        <input [readonly]="isAuth" placeholder="{{ 'placeholders.email' | translate }}" type="email" name="email"
          class="border border-principal py-2 px-4 text-lg sm:text-xl w-full" required
          [(ngModel)]="orderForm.customer.email" #email="ngModel" (key.enter)="checkMail()" (change)="checkMail()"
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" />
        <div *ngIf="email.invalid && (email.dirty || email.touched)">
          <div *ngIf="email.errors.required" class="py-1 text-danger text-sm" role="alert">
            {{ 'validaciones.emailObligatorio' | translate }}
          </div>

          <div *ngIf="email.errors?.pattern" class="py-1 text-danger text-sm" role="alert">
            {{ 'validaciones.emailValido' | translate }}
          </div>
        </div>
      </div>
      <div>
        <input [readonly]="isAuth" placeholder="{{ 'placeholders.nombre' | translate }}"
          class="border border-principal py-2 px-4 text-lg sm:text-xl w-full" required
          [(ngModel)]="orderForm.customer.name" #firstname="ngModel" />

        <div *ngIf="firstname.invalid && (firstname.dirty || firstname.touched)">
          <div *ngIf="firstname.errors.required" class="py-1 text-danger text-sm" role="alert">
            {{ 'validaciones.nombreObligatorio' | translate }}
          </div>
        </div>
      </div>
      <div>
        <input [readonly]="isAuth" placeholder="{{ 'placeholders.apellido' | translate }}"
          class="border border-principal py-2 px-4 text-lg sm:text-xl w-full" required
          [(ngModel)]="orderForm.customer.lastname" #lastname="ngModel" />

        <div *ngIf="lastname.invalid && (lastname.dirty || lastname.touched)">
          <div *ngIf="lastname.errors.required" class="py-1 text-danger text-sm" role="alert">
            {{ 'validaciones.apellidosObligatorios' | translate }}
          </div>
        </div>
      </div>
      <div class="col-span-2">
        <input type="number" [readonly]="isAuth" placeholder="{{ 'placeholders.telefono' | translate }}"
          class="border border-principal py-2 px-4 text-lg sm:text-xl w-full" [(ngModel)]="orderForm.customer.phone_ws"
          pattern="^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$" #phone="ngModel" required />
        <div *ngIf="phone.invalid && (phone.dirty || phone.touched)">
          <div *ngIf="phone.errors.required" class="py-1 text-danger text-sm" role="alert">
            {{ 'validaciones.tlfObligatorio' | translate }}
          </div>
          <div *ngIf="phone.errors.pattern" class="py-1 text-danger text-sm" role="alert">
            {{ 'validaciones.soloNumeros' | translate }}
          </div>
        </div>
      </div>

      <div class="checkbox-especial col-span-2 flex pt-2">
        <label class="control control-checkbox text-sm">
          <br />
          <!-- <a href="assets/imgs/POLITICA_DE_PROTECCION_DE_DATOS_PERSONALES_RUA_&_JEWELRY_SAS.pdf" target="_blank" download="POLITICA_DE_PROTECCION_DE_DATOS_PERSONALES_RUA_&_JEWELRY_SAS.pdf"> 
                            {{'carrito.masInformacion' | translate}}
                        </a> -->
          <input type="checkbox" name="checkbox" value="1" checked="checked" [(ngModel)]="tyc" />
          <div class="control_indicator"></div>
        </label>
        <a (click)="open('terms')" class="hover:underline focus:underline cursor-pointer">
          {{ 'instrucciones.terms' | translate }}</a>
      </div>

      <div class="checkbox-especial col-span-2 flex justify-between pt-3 border-t border-gris-medio mt-2" *ngIf="false">
        <label *ngIf="store.has_delivery == 1 && listPersonalized.length > 0" class="control control-checkbox text-sm">
          {{'carrito.envio' | translate}}
          <input type="radio" name="radio" value="1" checked="checked" [disabled]="listPersonalized === 0"
            [(ngModel)]="modoEntrega" />
          <div class="control_indicator"></div>
        </label>
        <ng-container *ngIf="listPersonalized.length === 0">
          <span class="text-xs">{{ 'validaciones.costoEnvio' | translate }}</span>
        </ng-container>

        <label *ngIf="store.pickup == 1" class="control control-checkbox text-sm whitespace-nowrap">
          {{ 'formEntrega.recogerTienda' | translate }}
          <input type="radio" name="radio" value="2" checked="checked" [(ngModel)]="modoEntrega" />
          <div class="control_indicator"></div>
        </label>
      </div>

      <div class="checkbox-especial col-span-2 flex mt-1 pt-3 border-t border-gris-medio">
        <div *ngIf="modoEntrega == 1" class="w-full flex gap-3 py-3">
          <button
            class="mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center bg-principal text-white px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300 rounded-full"
            (click)="goToDeliveryData()">
            {{ 'formEntrega.direccion' | translate }}
          </button>
        </div>

        <div *ngIf="modoEntrega == 2" class="w-full flex gap-3 py-3">
          <button (click)="validatePersonalData(true)"
            class="mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center bg-principal text-white px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300 rounded-full">
            {{ 'buttons.siguiente' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Entrega 1 -->
  <div *ngIf="store.has_delivery && modoEntrega == 1 && (step > 1 ||  step < 0)" class="my-4 bg-gris-extraclaro">
    <h2 *ngIf="!chooseAddress"
      class="font-dunbar w-full flex justify-between items-center uppercase sm:text-lg py-2 px-6 cursor-pointer"
      (click)="changeStep(2); chooseAddress = false; showMethods = false" [ngClass]="
        step == 2
          ? 'bg-gris-extraclaro'
          : 'mb-2 bg-gris-extraclaro hover:bg-principal-claro focus:bg-principal-claro'
      ">
      {{ 'carrito.entrega' | translate }}
      <span *ngIf="step > 2" class="material-icons-outlined mr-3">done</span>
    </h2>
    <div class="grid grid-cols-2 gap-3 py-4 px-4" *ngIf="step == 2">
      <div *ngIf="listPersonalized.length === 0" class=" ">
        <select class="border border-principal py-2 px-4 text-lg sm:text-xl w-full" name="city"
          [(ngModel)]="deliveryAddress.city" #city="ngModel">
          <option disabled value="">
            {{ 'placeholders.city' | translate }}
          </option>
          <option *ngFor="let ciudad of cuidades" [value]="ciudad">
            {{ ciudad }}
          </option>
        </select>
        <div *ngIf="city.invalid && (city.dirty || city.touched)">
          <div *ngIf="city.errors.required" class="py-1 text-danger text-sm" role="alert">
            {{ 'validaciones.ciudadObligatorio' | translate }}
          </div>
        </div>
      </div>

      <!-- <div  class=" ">
        <select (change)="codeDelivery = $event.target['value']" class="border border-principal py-2 px-4 text-lg sm:text-xl w-full">
          <option disabled selected hidden value="">{{'carrito.zonaEntrega' | translate }}</option>
          <option *ngFor="let item of providersDeliveryList" [value]="item.code">
            {{ item.name }}
          </option>
        </select>
      </div> -->

      <div *ngIf="listPersonalized.length > 0 && false" class=" ">
        <select (change)="id_personalized = $event.target['value']"
          class="border border-principal py-2 px-4 text-lg sm:text-xl w-full">
          <option disabled selected hidden value="">{{'carrito.zonaEntrega' | translate }}</option>
          <option *ngFor="let item of listPersonalized" [value]="item.id_number">
            {{ item.description }}
          </option>
        </select>
      </div>



      <div class="">
        <span class="text-black pl-2">
          {{ 'placeholders.direccion' | translate }}
        </span>
        <input placeholder="{{ 'placeholders.direccion' | translate }}"
          class="border border-principal py-2 px-4 text-lg sm:text-xl w-full" [(ngModel)]="deliveryAddress.street"
          #street="ngModel" required />

        <div *ngIf="street.invalid && (street.dirty || street.touched)">
          <div *ngIf="street.errors.required" class="py-1 text-danger text-sm" role="alert">
            {{ 'validaciones.direccionObligatorio' | translate }}
          </div>
        </div>
      </div>

      <!-- CITY -->
      <div class="">
        <span class="text-black pl-2">
          {{ 'placeholders.city' | translate }}
        </span>
        <input type="text" placeholder="{{ 'placeholders.city' | translate }}"
          class="border border-principal py-2 px-4 text-lg sm:text-xl w-full" [(ngModel)]="deliveryAddress.city"
          #city="ngModel" required />
        <div *ngIf="city.invalid && (city.dirty || city.touched)">
          <div *ngIf="city.errors.required" class="py-1 px-2 text-danger bg-principal-claro text-sm" role="alert">
            {{ 'validaciones.city' | translate }}
          </div>
        </div>
      </div>

      <!-- STATE -->
      <div class="">
        <span class="text-black pl-2">
          {{ 'placeholders.state' | translate }}
        </span>
        <select class="border border-principal py-2 px-4 text-lg sm:text-xl w-full" name="state"
          [(ngModel)]="deliveryAddress.state" #state="ngModel">
          <option *ngFor="let state of states" [value]="state" class="text-black bg-white">
            {{ state }}
          </option>
        </select>
        <div *ngIf="state.invalid && (state.dirty || state.touched)">
          <div *ngIf="state.errors.required" class="py-1 px-2 text-danger bg-principal-claro text-sm" role="alert">
            {{ 'validaciones.state' | translate }}
          </div>
        </div>
      </div>
      <!-- FIN STATE -->
      <div class="">
        <span class="text-black pl-2">
          {{ 'placeholders.postalCode' | translate }}
        </span>
        <input type="number" placeholder="{{ 'placeholders.postalCode' | translate }}"
          class="border border-principal py-2 px-4 text-lg sm:text-xl w-full" [(ngModel)]="deliveryAddress.zip_code"
          #zip_code="ngModel" required />
        <div *ngIf="zip_code.invalid && (zip_code.dirty || zip_code.touched)">
          <div *ngIf="zip_code.errors.required" class="py-1 text-danger text-sm" role="alert">
            {{ 'validaciones.codigoPostal' | translate }}
          </div>
        </div>
      </div>

      <div class="" *ngIf="false">
        <span class="text-black pl-2">
          {{ 'placeholders.telefono' | translate }}
        </span>
        <input type="number" placeholder=" {{ 'placeholders.telefono' | translate }} "
          class="border border-principal py-2 px-4 text-lg sm:text-xl w-full" [(ngModel)]="deliveryAddress.phone"
          #phone="ngModel" required />

        <div *ngIf="phone.invalid && (phone.dirty || phone.touched)">
          <div *ngIf="phone.invalid && (phone.dirty || phone.touched)">
            <div *ngIf="phone.errors.required" class="py-1 text-danger text-sm" role="alert">
              {{ 'validaciones.tlfObligatorio' | translate }}
            </div>
            <div *ngIf="phone.errors.pattern" class="py-1 text-danger text-sm" role="alert">
              {{ 'validaciones.soloNumeros' | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="" *ngIf="false">
        <span class="text-black pl-2">
          {{ 'placeholders.destinatario' | translate }}
        </span>
        <input placeholder="{{ 'formEntrega.destinatario' | translate }}"
          class="border border-principal py-2 px-4 text-lg sm:text-xl w-full" [(ngModel)]="deliveryAddress.destinatario"
          #destinatario="ngModel" required />
        <div *ngIf="
            destinatario.invalid && (destinatario.dirty || destinatario.touched)
          ">
          <div *ngIf="destinatario.errors.required" class="py-1 text-danger text-sm" role="alert">
            {{ 'validaciones.destinatarioObligatorio' | translate }}
          </div>
        </div>
      </div>

      <div class="col-span-2 flex flex-col gap-4 items-center">
        <!-- <button *ngIf="isAuth && deliveryAddress.city !== '' && deliveryAddress.street !== '' && deliveryAddress.destinatario !== '' " class="mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center bg-principal text-white px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300 rounded-full "
                    (click)="(step == 2 && isAuth) && showMethods = true; step = 4; ; getCost() ">
                    {{'buttons.siguiente' | translate}}
                </button> -->


        <!-- id_personalized || codeDelivery && -->
        <!-- *ngIf="
            deliveryAddress.city  &&
            deliveryAddress.street  &&
            deliveryAddress.zip_code &&
            deliveryAddress.state != '0' && !isAuth" -->
        <button
          [ngClass]="deliveryAddress.city  &&
            deliveryAddress.street  &&
            deliveryAddress.zip_code &&
            deliveryAddress.state != '0' &&
            !isAuth ? 'bg-principal text-white transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300' : 'bg-gray-500 text-white opacity-40 cursor-not-allowed'"
          class="mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center px-4 py-2 rounded-full" (click)="getCost()">
          {{ 'buttons.siguiente' | translate }}
        </button>
      </div>
      <button *ngIf="methodPayment === 'own'"
        class="mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center bg-principal text-white px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300 rounded-full"
        (click)="goToPaymentData()">
        {{ 'buttons.pagar' | translate }}
      </button>
    </div>
    <!-- <div class="" *ngIf="envioOptions.length > 0 && step == -1">
      <select (change)="getCostEnvio($event)" class="border border-principal py-2 px-4 text-lg sm:text-xl w-full">
        <option disabled selected hidden value="">{{'carrito.zonaEntrega' | translate }}</option>
        <option *ngFor="let item of envioOptions" [value]="item.serviceCode">
          {{ item.serviceName }}
        </option>
      </select>
    </div> -->
  </div>
  <div class="flex flex-row flex-wrap justify-start items-center gap-4 py-4 px-4" *ngIf="step == -2" [ngClass]="
        step == -2
          ? 'bg-gris-extraclaro'
          : 'mb-2 bg-gris-extraclaro hover:bg-principal-claro focus:bg-principal-claro'
      ">
    <div class="flex flex-row flex-wrap justify-start items-start gap-2">
      <h2 class="font-dunbar w-full flex justify-between items-center uppercase sm:text-lg px-2">USPS</h2>
      <!-- <div class="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        <button type="button" *ngFor="let item of DeliveryServiceList; let i = index" (click)="setDelivery(item)"
          class="text-sm bg-principal border border-principal text-center py-2 px-6 text-white hover:bg-principal-hover hover:border-principal-hover focus:bg-principal-hover focus:border-principal-hover rounded-full flex flex-col items-center">
          <span class="flex justify-between w-full flex-col items-center">
            <span>{{ item.service }}</span>
            <span class="font-dunbar text-lg">{{ item.cost | currency }}</span>
          </span>
          <span class="text-xs">{{ item.delivery_time }}</span>
        </button>
      </div> -->
   
      <div class="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 auto-rows-fr">
        <button
          type="button"
          *ngFor="let item of DeliveryServiceList; let i = index"
          (click)="setDelivery(item)"
          class="text-sm bg-principal border border-principal text-center py-2 px-6 text-white hover:bg-principal-hover hover:border-principal-hover focus:bg-principal-hover focus:border-principal-hover rounded-md
                 flex flex-col justify-between items-center h-full"
        >
          <div class="flex flex-col items-center">
            <span>{{ item.service }}</span>
            <span class="font-dunbar text-lg">{{ item.cost | currency }}</span>
          </div>
          <span class="text-xs">{{ item.delivery_time }}</span>
        </button>
      </div>

      <!-- fin -->
    </div>

  </div>


  <!-- escoger direccion inicio -->
  <div>
    <div class="my-4 bg-gris-extraclaro">
      <h2 *ngIf="chooseAddress"
        class="font-dunbar w-full flex justify-between items-center uppercase sm:text-lg py-2 px-6 cursor-pointer"
        (click)="changeStep(3); chooseAddress = true; showMethods = false" [ngClass]="
          step == 3
            ? 'bg-gris-extraclaro'
            : 'mb-2 bg-gris-extraclaro hover:bg-principal-claro focus:bg-principal-claro'
          ">
        {{ 'pagePerfil.direccionesEntrega' | translate
        }}<span *ngIf="step > 3" class="material-icons-outlined mr-3">done</span>
      </h2>
      <!-- ocultar este div cuando se hace click en pagar -->
      <div *ngIf="step == 3 && chooseAddress" class="pb-4 px-4">
        <div tabindex="0" role="button" (click)="
            id_address = address.id;
            showMethods = true;
            step = 4;
            checkAddress(address)
          " *ngFor="let address of listAddresses; let i = index"
          class="grid grid-cols-4 gap-y-1 gap-x-2 p-4 relative border-b border-gris-oscuro bg-principal-claro hover:bg-principal-hover focus-within:bg-principal-hover text-gris-medio hover:text-principal focus:text-principal focus-within:outline-none">
          <div class="text-gris-medio">
            {{ 'formDirecciones.calle' | translate }}
          </div>
          <div class="col-span-2 text-gris-oscuro">{{ address.street }}</div>
          <div class="justify-self-end flex items-center">
            <span class="material-icons-outlined">done</span>
          </div>
          <div class="text-gris-medio">
            {{ 'formDirecciones.zip' | translate }}
          </div>
          <div class="col-span-3 text-gris-oscuro">{{ address.zip_code }}</div>
          <div class="text-gris-medio">
            {{ 'formDirecciones.ciudad' | translate }}
          </div>
          <div class="col-span-3 text-gris-oscuro">{{ address.city }}</div>
          <div class="text-gris-medio">
            {{ 'formDirecciones.estado' | translate }}
          </div>
          <div class="col-span-3 text-gris-oscuro">{{ address.state }}</div>
        </div>
      </div>
      <!-- fin div ocultar -->
    </div>
  </div>
  <!-- escoger direccion fin -->

  <!-- Entrega 2-->
  <div class="my-4 bg-gris-extraclaro" *ngIf="modoEntrega == 2 && step > 1">
    <h2 class="font-dunbar w-full flex justify-between items-center uppercase sm:text-lg py-2 px-6 cursor-pointer"
      [ngClass]="
        modoEntrega == 2
          ? 'bg-gris-extraclaro'
          : 'mb-2 bg-gris-extraclaro hover:bg-principal-claro focus:bg-principal-claro'
      ">
      {{ 'formEntrega.recogerTienda' | translate }}
      <span *ngIf="step > 2" class="material-icons-outlined mr-3">done</span>
    </h2>
    <div class="px-6 py-3 flex flex-col">
      <h3 class="font-bold">{{ 'carrito.direccionTienda' | translate }}</h3>
      <label>{{ store.address }}, {{ store.cep }} , {{ store.city }}</label>
      <label>{{ store.phone }}</label>
    </div>
  </div>



  <!-- escoger metodos pago -->
  <div *ngIf=" step > 3" class="my-4 bg-gris-extraclaro">
    <div>
      <h2 class="font-dunbar w-full flex justify-between items-center uppercase sm:text-lg py-2 px-6 cursor-pointer"
        (click)="changeStep(4); showMethods = true" [ngClass]="
          showMethods
            ? 'bg-gris-extraclaro'
            : 'mb-2 bg-gris-extraclaro hover:bg-principal-claro focus:bg-principal-claro'
        ">
        {{ 'checkout.escogerMetodosPago' | translate }}
        <span *ngIf="step > 4" class="material-icons-outlined mr-3">done</span>
      </h2>
    </div>

    <div *ngIf="step == 4 || showMethods" class="flex flex-wrap gap-4 py-3 mx-4">
      <button *ngFor="let method of metodos_payment" (click)="changeStates(method.model, method.name)"
        class="mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center bg-principal text-white px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300 rounded-full">
        {{
        method.model !== 'custompayment'
        ? (method.model | translate)
        : method.name
        }}
      </button>
    </div>
  </div>
  <!-- fin metodos pago -->

  <!-- form subir imagen -->

  <div *ngIf="methodPayment === 'transfer'" class="my-4 bg-gris-extraclaro">
    <h2 class="font-dunbar w-full flex justify-between items-center uppercase sm:text-lg py-2 px-6 cursor-pointer"
      (click)="changeStep(5)" [ngClass]="
        step == 5
          ? 'bg-gris-extraclaro'
          : 'mb-2 bg-gris-extraclaro hover:bg-principal-claro focus:bg-principal-claro'
      ">
      {{ 'comprobante' | translate }}
      <span *ngIf="step > 5" class="material-icons-outlined mr-3">done</span>
    </h2>

    <div *ngIf="step === 4" class="flex flex-col flex-wrap gap-1 text-sm py-4 px-4 m-4 bg-gris-claro rounded">
      <p><strong>Nombre Titular/Empresa:</strong> {{ dataPayment.name }}</p>
      <p><strong>Cédula o RIF:</strong> {{ dataPayment.rif }}</p>
      <p><strong>Numero de Cuenta:</strong> {{ dataPayment.number_account }}</p>
      <p><strong>Banco:</strong> {{ dataPayment.bank_name }}</p>
    </div>

    <div class="" *ngIf="step === 4">
      <form class="mx-4 pb-3 flex flex-wrap gap-3 justify-between">
        <div
          class="relative mt-5 max-w-full flex bg-white text-lg sm:text-xl border border-principal items-center focus-within:border-principal">
          <label for="ref" class="uppercase text-xs absolute -top-5 left-0">N° Referencia</label>
          <span class="absolute material-icons-outlined ml-3">payment</span>
          <input [(ngModel)]="ref" name="ref" id="ref" class="w-full py-2 pl-12 focus:outline-none" type="text"
            placeholder="N° Referencia" />
        </div>

        <img class="object-contain flex justify-center align-center rounded" *ngIf="!isPdf && url_comprobante !== ''"
          [src]="url_comprobante" alt="" />

        <embed *ngIf="isPdf && url_comprobante !== ''" [src]="url_comprobante" width="400" height="200"
          type="application/pdf" />

        <div class="">
          <button (click)="simulateClick()"
            class="w-full mt-4 bg-principal border border-principal text-center py-2 px-5 text-info hover:bg-principal-hover hover:border-principal-hover focus:bg-principal-hover focus:border-principal-hover rounded">
            Cargar comprobante
          </button>
          <input class="hidden" type="file" #inputFile (change)="handleImg($event)" />
        </div>
      </form>
    </div>
  </div>

  <!-- fin form subir imagen -->

  <!-- metodo de pago personalizado -->

  <div *ngIf="methodPayment === 'custompayment'" class="my-4 p-4 bg-white rounded ">
    <div [innerHTML]="dataPayment.description"></div>
    <img style="width: 20%; margin: 8px auto" *ngIf="dataPayment.image !== '-'" [src]="dataPayment.image" alt="" />

    <img class="object-contain flex justify-center align-center rounded" *ngIf="!isPdf && url_comprobante !== ''"
      [src]="url_comprobante" alt="" />

    <embed *ngIf="isPdf && url_comprobante !== ''" [src]="url_comprobante" width="400" height="200"
      type="application/pdf" />

    <div *ngIf="dataPayment.voucher_required === 1 && dataPayment.voucher_required" class="">
      <button (click)="simulateClick()"
        class="w-full mt-4 bg-principal border border-principal text-center py-2 px-5 text-info hover:bg-principal-hover hover:border-principal-hover focus:bg-principal-hover focus:border-principal-hover rounded">
        Cargar comprobante
      </button>
      <input class="hidden" type="file" #inputFile (change)="handleImg($event)" />
    </div>
  </div>

  <!-- fin personaliazdo -->

  <!-- metodo agreement -->

  <div >
    <button *ngIf="(!showCouponInput && !couponState.success) && canShowCouponUI()" (click)="toggleCouponInput()"
      class="m-2 bg-gris-claro text-info  px-4 py-2 rounded-md transition-colors duration-200 whitespace-nowrap">
      Have a coupon?
    </button>
    <div class="col-span-2 mt-4 px-4">
      <div *ngIf="showCouponInput && canShowCouponUI()" class="flex flex-col gap-2">
        <label for="couponCode" class="block text-sm font-medium text-gray-700 mb-1">
          Enter your coupon code:
        </label>
        <div class="flex items-center gap-2">
          <input type="text" id="couponCode" name="couponCode" placeholder="Coupon code"
            class="flex-grow p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-principal focus:border-transparent"
            [(ngModel)]="couponCodeInput" />
          <button type="button"
            class="bg-principal text-white px-4 py-2 rounded-md hover:opacity-90 transition-opacity duration-200"
            (click)="applyCoupon()" [disabled]="loadingCoupon">
            {{ loadingCoupon ? 'Applying...' : 'Apply' }}
          </button>
        </div>
        <p *ngIf="couponState.error" class="text-red-600 text-sm mt-2">
          {{ couponState.error }}
        </p>
        <p *ngIf="loadingCoupon" class="text-blue-600 text-sm mt-2">
          Verifying coupon...
        </p>
      </div>

      <p *ngIf="couponState.success && couponState.summary"
        class="text-green-600 text-sm mt-2 p-2 border border-green-300 bg-green-50 rounded-md">
        <span class="font-bold">Coupon applied: </span>
        <span class="font-semibold text-principal">{{ couponState.couponDetails?.code }}</span>
        <span class="font-semibold ml-2">
          - {{ couponState.summary.discount_amount | currencyPersonalized }}
        </span>
        <span *ngIf="couponState.couponDetails?.discount_type === 'percentage'">
          ({{ couponState.couponDetails.discount_value }}%)
        </span>
        <span *ngIf="couponState.couponDetails?.discount_type === 'fixed'">
          (Fixed discount)
        </span>
        <button type="button" (click)="removeCoupon()"
          class="ml-4 text-red-600 hover:text-red-800 text-sm font-semibold underline">
          Remove coupon
        </button>
      </p>
    </div>
  </div>

  <ng-container *ngIf="methodPayment === 'agreement'">
    <div class="flex flex-col">
      <p class="text-center">{{ dataPayment.texto1 }}</p>
      <p class="text-center">{{ dataPayment.texto2 }}</p>
      <button
        class="my-4 mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center bg-principal text-white px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300 rounded-full"
        (click)="methodPayment !== '' ? makeOrder() : goToPaymentData()">
        {{ 'buttons.pagar' | translate }}
      </button>
    </div>
  </ng-container>

  <!-- fin metodo agreement -->

  <!-- form de stripe -->

  <div *ngIf="methodPayment === 'stripe'" class="my-4 bg-gris-extraclaro">
    <div class="flex justify-between items-center">
      <h2 class="font-dunbar w-full flex justify-between items-center uppercase sm:text-lg py-2 px-6 cursor-pointer"
        (click)="changeStep(5)" [ngClass]="
        step == 5
          ? 'bg-gris-extraclaro'
          : 'mb-2 bg-gris-extraclaro hover:bg-principal-claro focus:bg-principal-claro'
      ">
        {{ 'checkout.formPago' | translate }}
        <span *ngIf="step > 5" class="material-icons-outlined mr-3 text-white">done</span>
      </h2>
      <!-- Oculta cupon para subs isSub == false &&  -->
      <!-- <button *ngIf="(!showCouponInput && !couponState.success) && false" (click)="toggleCouponInput()"
        class="m-2 bg-gris-claro text-info  px-4 py-2 rounded-md transition-colors duration-200 whitespace-nowrap">
        Have a coupon?
      </button> -->
    </div>

    <div class="w-full" *ngIf="step === 5">
      <div *ngIf="false && isSub" class="flex justify-center p-4 bg-white rounded">
        <form class="w-full flex flex-wrap gap-y-3 justify-between px-2">
          <div
            class="relative mt-5 w-full flex bg-white text-lg sm:text-xl border border-principal items-center focus-within:border-principal">
            <label for="card-number" class="uppercase text-xs absolute -top-5 left-0">
              {{ 'formStripe.cardNumber' | translate }}
            </label>
            <span class="absolute material-icons-outlined ml-3">payment</span>
            <input class="w-full py-2 pl-12 focus:outline-none" type="text" id="card-number" name="card-number"
              placeholder="{{ 'formStripe.cardNumber' | translate }}" [(ngModel)]="cardForm.cardNumber"
              [maxlength]="cardForm.maxLength" (keyup)="validate()" [imask]="cardForm.imask" [unmask]="true" />
          </div>
          <div
            class="relative mt-5 w-full flex bg-white text-lg sm:text-xl border border-principal items-center focus-within:border-principal">
            <label for="name" class="uppercase text-xs absolute -top-5 left-0">{{ 'formStripe.nombre' | translate
              }}</label>
            <span class="absolute material-icons-outlined ml-3">person</span>
            <input name="name" class="w-full py-2 pl-12 focus:outline-none" type="text" id="name"
              [(ngModel)]="cardForm.name" placeholder="{{ 'formStripe.nombre' | translate }}" />
          </div>
          <div
            class="relative mt-5 w-max flex bg-white text-lg sm:text-xl border border-principal items-center focus-within:border-principal">
            <label for="expirationDate" class="uppercase text-xs absolute -top-5 left-0">{{ 'formStripe.expiracion' |
              translate }}</label>
            <span class="absolute material-icons-outlined ml-3">today</span>
            <input name="expirationDate" [(ngModel)]="cardForm.expirationDate"
              class="w-36 py-2 pl-12 focus:outline-none" type="text" id="validity-date" placeholder="00/0000"
              [imask]="{ mask: '00/0000' }" />
          </div>

          <div
            class="relative mt-5 w-1/2 flex bg-white text-lg sm:text-xl border border-principal items-center focus-within:border-principal">
            <label for="securityCode" class="uppercase text-xs absolute -top-5 left-0 whitespace-nowrap">{{
              'formStripe.cod' | translate }}</label>
            <span class="absolute material-icons-outlined ml-3">lock</span>
            <input type="password" id="cvv" name="cvv" [(ngModel)]="cardForm.cvv" [maxlength]="cardForm.maxCvvLength"
              placeholder="000" class="w-28 py-2 pl-12 focus:outline-none" />
          </div>
        </form>
      </div>
      <div *ngIf="false && isSub" class="mt-4 mb-8">
        <button
          class="mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center bg-principal text-white px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300 rounded-full"
          (click)="methodPayment !== '' ? makeOrder() : goToPaymentData()">
          {{ 'buttons.pagar' | translate }}
        </button>
      </div>

      <!--*INICIO NUEVA SECCION -->
      <!-- <div class="col-span-2 mt-4 px-4">


        <div *ngIf="showCouponInput" class="flex flex-col gap-2">
          <label for="couponCode" class="block text-sm font-medium text-gray-700 mb-1">
            Enter your coupon code:
          </label>
          <div class="flex items-center gap-2">
            <input type="text" id="couponCode" name="couponCode" placeholder="Coupon code"
              class="flex-grow p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-principal focus:border-transparent"
              [(ngModel)]="couponCodeInput" />
            <button type="button"
              class="bg-principal text-white px-4 py-2 rounded-md hover:opacity-90 transition-opacity duration-200"
              (click)="applyCoupon()" [disabled]="loadingCoupon">
              {{ loadingCoupon ? 'Applying...' : 'Apply' }}
            </button>
          </div>
          <p *ngIf="couponState.error" class="text-red-600 text-sm mt-2">
            {{ couponState.error }}
          </p>
          <p *ngIf="loadingCoupon" class="text-blue-600 text-sm mt-2">
            Verifying coupon...
          </p>
        </div>

        <p *ngIf="couponState.success && couponState.summary"
          class="text-green-600 text-sm mt-2 p-2 border border-green-300 bg-green-50 rounded-md">
          <span class="font-bold">Coupon applied: </span>
          <span class="font-semibold text-principal">{{ couponState.couponDetails?.code }}</span>
          <span class="font-semibold ml-2">
            - {{ couponState.summary.discount_amount | currencyPersonalized }}
          </span>
          <span *ngIf="couponState.couponDetails?.discount_type === 'percentage'">
            ({{ couponState.couponDetails.discount_value }}%)
          </span>
          <span *ngIf="couponState.couponDetails?.discount_type === 'fixed'">
            (Fixed discount)
          </span>
          <button type="button" (click)="removeCoupon()"
            class="ml-4 text-red-600 hover:text-red-800 text-sm font-semibold underline">
            Remove coupon
          </button>
        </p>
      </div> -->
      <!-- Go to Payment -->
      <div class="px-6 my-6 bg-gris-extraclaro w-full" *ngIf="isSub == false">
        <div id="payment-element"></div>
        <button (click)="pagar()" *ngIf=" methodPayment === 'stripe' && stripeReturnURL != '' && isMountCard"
          class="my-2 mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center bg-principal text-white px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300 rounded-full">Pagar</button>
      </div>
      <div class="px-6 my-6 bg-gris-extraclaro w-full" *ngIf="isSub">
        <div id="card-element"></div>
        <button *ngIf="isMountCard" (click)="makeOrder()"
          class="my-4 mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center bg-principal text-white px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300 rounded-full">
          pagar
        </button>
      </div>
    </div>

  </div>



  <!-- fin form stripe -->

  <!-- pagar por transfer -->
  <div class="col-span-2 flex gap-4 mt-4">
    <button *ngIf="methodPayment === 'transfer' && url_comprobante !== ''"
      class="mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center bg-principal text-white px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300 rounded-full"
      (click)="methodPayment !== '' ? makeOrder() : goToPaymentData()">
      {{ 'buttons.pagar' | translate }}
    </button>

    <button *ngIf="methodPayment === 'custompayment'"
      class="mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center bg-principal text-white px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300 rounded-full"
      (click)="methodPayment !== '' ? makeOrder() : goToPaymentData()">
      {{ 'buttons.pagar' | translate }}
    </button>
  </div>
  <!-- fin pagar por transfer -->

  <!-- pagar por agreement -->
  <div class="col-span-2 flex gap-4 mt-4">
    <button *ngIf="methodPayment === 'agreement' && url_comprobante !== ''"
      class="mx-8 w-4/5 flex-1 whitespace-nowrap uppercase text-center bg-principal text-white px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-300 rounded-full"
      (click)="methodPayment !== '' ? makeOrder() : goToPaymentData()">
      {{ 'buttons.pagar' | translate }}
    </button>
  </div>
  <!-- fin pagar por agreement -->

  <!-- Carro -->
  <div class="my-4 bg-gris-extraclaro">
    <div>
      <!-- (click)="showMyOrder = !showMyOrder"  -->
      <h2 class="font-dunbar w-full flex justify-between items-center uppercase sm:text-lg py-2 px-6 cursor-pointer "
        [ngClass]="
          showMyOrder
            ? 'bg-gris-extraclaro'
            : 'mb-2 bg-gris-extraclaro hover:bg-principal-claro focus:bg-principal-claro'
        ">
        {{ 'carrito.miPedido' | translate }}
      </h2>
    </div>
    <div *ngIf="showMyOrder|| true" class="flex flex-col pb-4 px-4 max-h-96 overflow-auto">
      <div class="product flex gap-3 py-4 border-b border-gris-medio" *ngFor="let productCart of cart; let i = index">
        <div class="w-16 h-16 flex items-stretch relative">
          <img [src]="
              productCart.variation.images.length > 0
                ? productCart.variation.images[0].url
                : productCart.product.images.length > 0 ? productCart.product.images[0].url : default_photo
            " class="w-full h-full object-cover" />
        </div>

        <div class="flex-1 flex flex-col gap-3 justify-between">
          <p class="text-sm uppercase font-semibold leading-4">
            {{ productCart.variation.name }}
          </p>
          <div class="flex h-8 items-center self-end">
            <span class="mr-3">{{ productCart.variation.quantity }} x</span>
            <!-- <p class="uppercase text-right text-lg h-8 flex items-center px-4 font-bold">
              {{ (productCart.variation.sale_price > 0 ? productCart.variation.sale_price : isSub ? (productCart.variation.discountPrice || productCart.variation.price) : productCart.variation.price) | currencyPersonalized }}
            </p> -->

            <div class="flex flex-col md:w-full lg:w-2/4">
              <!-- <p *ngIf="productCart.variation.sale_price > 0 || isSub" class="text-gris-claro text-base font-bold leading-6 md:text-center lg:text-left line-through whitespace-nowrap">
                  {{ (productCart.variation.sale_price > 0 ? productCart.variation.sale_price : productCart.variation.price) | currencyPersonalized }}
                </p>
                <p class="text-base lg:text-lg font-bold leading-6 md:text-center lg:text-left whitespace-nowrap">
                          {{ 
                            isSub && productCart.variation.discountPrice > 0
                              ? ((productCart.variation.discountPrice)  | currencyPersonalized)
                              : (productCart.variation.sale_price > 0 
                                  ? (productCart.variation.sale_price   | currencyPersonalized)
                                  : (productCart.variation.price  | currencyPersonalized)) 
                          }}
                </p> -->
              <ng-container *ngIf="!isSub; else subscribeTemplate">
                <p class="font-semibold text-lg uppercase h-6 flex items-center whitespace-nowrap"
                  [ngClass]="productCart.variation.sale_price > 0 ? 'text-gris-medio line-through': 'text-principal' ">
                  {{productCart.variation.price | currencyPersonalized}}
                </p>
                <p *ngIf="productCart.variation.sale_price > 0"
                  class="pl-2 text-principal font-semibold text-lg uppercase h-6 flex items-center whitespace-nowrap">
                  {{productCart.variation.sale_price | currencyPersonalized}}
                </p>
              </ng-container>

              <ng-template #subscribeTemplate>
                <!-- VOLVER A ACTIVAR POST EVENTO REDNUMBERS -->
                <!-- <p *ngIf="productCart.variation.sale_price > 0" class="font-semibold text-lg uppercase h-6 flex items-center whitespace-nowrap text-gris-claro line-through">
                            {{ productCart.variation.sale_price  | currencyPersonalized}}
                        </p>
                        <p *ngIf="productCart.variation.sale_price === 0" class="font-semibold text-lg uppercase h-6 flex items-center whitespace-nowrap text-gris-claro line-through">
                            {{ productCart.variation.price  | currencyPersonalized}}
                        </p> -->
                <p
                  class="font-semibold text-lg uppercase h-6 flex items-center whitespace-nowrap text-gris-claro line-through">
                  {{ productCart.variation.price | currencyPersonalized}}
                </p>
                <p class="pl-2 text-principal font-semibold text-lg uppercase h-6 flex items-center whitespace-nowrap">
                  {{ productCart.variation.discountPrice | currencyPersonalized}}
                </p>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>




    <!--*INICIO NUEVA SECCION -->
    <div class="col-span-2 mt-4 px-4" *ngIf="false">
      <button *ngIf="!showCouponInput && !couponState.success" (click)="toggleCouponInput()"
        class="bg-principal text-white px-4 py-2 rounded-md transition-colors duration-200">
        Have a coupon?
      </button>

      <div *ngIf="showCouponInput" class="flex flex-col gap-2">
        <label for="couponCode" class="block text-sm font-medium text-gray-700 mb-1">
          Enter your coupon code:
        </label>
        <div class="flex items-center gap-2">
          <input type="text" id="couponCode" name="couponCode" placeholder="Coupon code"
            class="flex-grow p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-principal focus:border-transparent"
            [(ngModel)]="couponCodeInput" />
          <button type="button"
            class="bg-principal text-white px-4 py-2 rounded-md hover:opacity-90 transition-opacity duration-200"
            (click)="applyCoupon()" [disabled]="loadingCoupon">
            {{ loadingCoupon ? 'Applying...' : 'Apply' }}
          </button>
        </div>
        <p *ngIf="couponState.error" class="text-red-600 text-sm mt-2">
          {{ couponState.error }}
        </p>
        <p *ngIf="loadingCoupon" class="text-blue-600 text-sm mt-2">
          Verifying coupon...
        </p>
      </div>

      <p *ngIf="couponState.success && couponState.summary"
        class="text-green-600 text-sm mt-2 p-2 border border-green-300 bg-green-50 rounded-md">
        <span class="font-bold">Coupon applied: </span>
        <span class="font-semibold text-principal">{{ couponState.couponDetails?.code }}</span>
        <span class="font-semibold ml-2">
          - {{ couponState.summary.discount_amount | currencyPersonalized }}
        </span>
        <span *ngIf="couponState.couponDetails?.discount_type === 'percentage'">
          ({{ couponState.couponDetails.discount_value }}%)
        </span>
        <span *ngIf="couponState.couponDetails?.discount_type === 'fixed'">
          (Fixed discount)
        </span>
        <button type="button" (click)="removeCoupon()"
          class="ml-4 text-red-600 hover:text-red-800 text-sm font-semibold underline">
          Remove coupon
        </button>
      </p>
    </div>


    <div class="bg-white grid grid-cols-2 gap-2 justify-between p-4 items-center rounded mt-4">
      <p>Subtotal</p>
      <p class="justify-self-end">
        {{ getDisplaySubtotal() | currencyPersonalized }}
      </p>
      <hr class="col-span-2 border-t border-principal" />

      <ng-container *ngIf="couponState.success && couponState.summary && couponState.summary.discount_amount > 0">
        <p class="text-md text-red-600">Coupon Discount <span *ngIf="isSub && (getDisplaySubtotal() <= 65)"> + Free
            shipping </span>
          <span *ngIf="isSub" class=" block text-xs"> (First purchase only)</span>
        </p>
        <p class="justify-self-end text-red-600">
          - {{ couponState.summary.discount_amount | currencyPersonalized }}
        </p>
        <hr class="col-span-2 border-t border-principal" />
      </ng-container>


      <ng-container *ngIf="modoEntrega == '1' && (step >= 4 || getDisplaySubtotal() > 65)">
        <p>Shipping </p>
        <p class="justify-self-end flex flex-row gap-2">
          <span *ngIf="getCalculatedShipping() > 0">
            {{ getCalculatedShipping() | currencyPersonalized }}
          </span>
          <span *ngIf="getCalculatedShipping() === 0 && envio > 0" class="line-through block">{{envio |
            currencyPersonalized }}</span>
          <span *ngIf="getCalculatedShipping() === 0">
            Free
          </span>
        </p>
        <hr class="col-span-2 border-t border-principal" />
      </ng-container>


      <ng-container>
        <p>Taxes:</p>
        <p class="justify-self-end">
          {{ calculateTransactionFee() | currencyPersonalized }}
        </p>
        <hr class="col-span-2 border-t border-principal" />
      </ng-container>

      <p class="uppercase text-2xl font-bold">Total</p>
      <p class="text-2xl justify-self-end font-bold">
        {{ getTotalAmount() | currencyPersonalized }}
      </p>
      <hr class="col-span-2 border-t border-principal" />
      <ng-container *ngIf="isSub && couponState.success">
        <p></p>
        <p class="justify-self-end text-gris-medio text-sm font-bold">
          Total in the renewal {{getTotalRenewal() | currencyPersonalized}}
        </p>
        <hr class="col-span-2 border-t border-principal" />
      </ng-container>
    </div>

    <!--* FIN NUEVA SEECCION  -->

  </div>
</div>